import React from "react";
import { handleGetAppLogo } from "../../../utils/constants/GlobalAppAndLanguage";
import useGlobalAppAndLanguage from "../../../hooks/useGlobalAppAndLanguage";

/** Logo and "App · Language", as a pill or an inline line; falls back to the switched app. */
const GlobalAppBadge = ({ app, language, inline = false, className = "" }) => {
  const { globalApp, globalLanguage, handleGlobalLabel } =
    useGlobalAppAndLanguage();
  const shown = {
    app: (app || globalApp || "").toLowerCase(),
    language: (language || globalLanguage || "").toLowerCase(),
  };

  return (
    <span
      className={`inline-flex min-w-0 items-center whitespace-nowrap font-medium text-[#3c3489] ${
        inline
          ? "gap-1 text-[10px] leading-4"
          : "h-7 shrink-0 gap-1.5 rounded-full border border-[#d9d4f5] bg-[#efedfc] pl-1 pr-2.5 text-xs"
      } ${className}`}
    >
      <img
        src={handleGetAppLogo({ app: shown.app })}
        alt=""
        className={`shrink-0 rounded-full object-cover ring-1 ring-black/5 ${
          inline ? "h-3 w-3" : "h-5 w-5"
        }`}
      />
      <span className="truncate">{handleGlobalLabel(shown)}</span>
    </span>
  );
};

export default GlobalAppBadge;
